import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '@/lib/queryClient';
import type { CustomerAttributionJourney as Journey } from '@shared/customer-attribution-journey';
import { Card, CardContent } from '@/components/ui/card';
import { describeLeadSource } from './leadSource';

/** Where the customer came from and when. Tracking detail stays in the database. */
export function LeadSourceCard({
  customerId,
  customerSource,
}: {
  customerId: number;
  customerSource?: string | null;
}) {
  const { data, isLoading } = useQuery({
    queryKey: ['/api/pipeline/analytics/marketing-attribution/customers', customerId],
    queryFn: () =>
      apiRequest<{ success: boolean; data: Journey }>(
        'GET',
        `/api/pipeline/analytics/marketing-attribution/customers/${customerId}`
      ),
    enabled: Number.isSafeInteger(customerId) && customerId > 0,
  });
  const { source, detail } = describeLeadSource(data?.data, customerSource);

  return (
    <Card className="mt-4">
      <CardContent className="space-y-1 p-4">
        <p className="text-xs font-medium text-muted-foreground">Lead source</p>
        {isLoading ? (
          <div className="h-11 space-y-2 pt-1" aria-hidden="true">
            <div className="h-4 w-40 animate-pulse rounded bg-muted" />
            <div className="h-3 w-64 animate-pulse rounded bg-muted" />
          </div>
        ) : (
          <>
            <p className="text-base font-medium">{source}</p>
            {detail && <p className="text-sm text-muted-foreground">{detail}</p>}
          </>
        )}
      </CardContent>
    </Card>
  );
}
